import { GridFilterModel, GridPaginationModel } from "@mui/x-data-grid-premium";
import { createSlice } from "@reduxjs/toolkit";
import HbsIslemtanimDTO from "src/models/GenelTanimlar/hbsislemtanimDTO";
import VwHbsIslemtanimDTO from "src/models/GenelTanimlar/VwHbsIslemtanimDTO";
import VwTestDetaybilgiDTO from "src/models/GenelTanimlar/VwTestDetaybilgiDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import { ApiResponse } from "src/services/core";
import { RootState } from "src/store";

type IslemTanimDataResponse = ApiResponse<Array<VwHbsIslemtanimDTO>> & {
    isFetching: boolean;
};
interface IIslemTanim {
    activeRow?: HbsIslemtanimDTO;
    open?: boolean;
    genKods?: Array<string>;
    testDetayBilgiDialogOpen?: boolean;
    testDetayBilgiEkleDialogOpen?: boolean;
    testDetayBilgiActiveRow?: VwTestDetaybilgiDTO;

    searchText?: string;
    paginationModel: GridPaginationModel;
    filterModel?: GridFilterModel;
    islemTanimData?: IslemTanimDataResponse;
}

export const IslemTanimSlice = createSlice<IIslemTanim, MapReducerPayloads<IIslemTanim, {
    setActiveRow?: HbsIslemtanimDTO;
    setOpen?: boolean;
    setGenKods?: Array<string>;
    setTestDetayBilgiDialogOpen?: boolean;
    setTestDetayBilgiEkleDialogOpen?: boolean;
    setTestDetayBilgiActiveRow?: VwTestDetaybilgiDTO;

    setSearchText?: string;
    setPaginationModel: GridPaginationModel;
    setFilterModel?: GridFilterModel;
    setIslemTanimData?: IslemTanimDataResponse;
}>>({
    name: "IslemTanim",
    initialState: {
        activeRow: {
            ...new HbsIslemtanimDTO(),
            kdvoran: 10
        },
        open: false,
        genKods: [],
        testDetayBilgiDialogOpen: false,
        testDetayBilgiEkleDialogOpen: false,
        testDetayBilgiActiveRow: new VwTestDetaybilgiDTO(),

        searchText: "",
        paginationModel: { page: 0, pageSize: 100 },
        filterModel: { items: [] },
        islemTanimData: {
            isFetching: false,
            data: [],
            errorMessage: "",
            responseCode: 0,
            totalRecords: 0,
            version: ""
        },
    },
    reducers: {
        setActiveRow: (state, action) => {
            state.activeRow = action.payload
        },
        setOpen: (state, action) => {
            state.open = action.payload
        },
        setGenKods: (state, action) => {
            state.genKods = action.payload
        },
        setTestDetayBilgiDialogOpen: (state, action) => {
            state.testDetayBilgiDialogOpen = action.payload
        },
        setTestDetayBilgiEkleDialogOpen: (state, action) => {
            state.testDetayBilgiEkleDialogOpen = action.payload
        },
        setTestDetayBilgiActiveRow: (state, action) => {
            state.testDetayBilgiActiveRow = action.payload
        },
        setSearchText: (state, action) => {
            state.searchText = action.payload
        },
        setPaginationModel: (state, action) => {
            state.paginationModel = action.payload
        },
        setFilterModel: (state, action) => {
            state.filterModel = action.payload
        },
        setIslemTanimData: (state, action) => {
            state.islemTanimData = action.payload
        },
    },
});

export const getHbsIslemTanimActiveRow = (state: RootState) => state.IslemTanim.activeRow;
export const getTestDetayBilgiDialogOpen = (state: RootState) => state.IslemTanim.testDetayBilgiDialogOpen;
export const getTestDetayBilgiEkleDialogOpen = (state: RootState) => state.IslemTanim.testDetayBilgiEkleDialogOpen;
export const getTestDetayBilgiActiveRow = (state: RootState) => state.IslemTanim.testDetayBilgiActiveRow;

export const {
    setTestDetayBilgiDialogOpen,
    setTestDetayBilgiEkleDialogOpen,
    setTestDetayBilgiActiveRow
} = IslemTanimSlice.actions;